export function isCapCategoryProduct(categoryId) {
    return parseInt(categoryId, 10) === 86;
}

export function doesImageUrlContainHatTag(imageUrl) {
    if (!imageUrl || typeof imageUrl !== "string") return false;
    const normalizedUrl = imageUrl.toLowerCase();
    if (normalizedUrl.includes("hat_")) return true;
    return /(?:^|[^a-z])hat(?:_|[^a-z]|$)/.test(normalizedUrl);
}

export function shouldApplyCapCategoryClassStrict(categoryId, imageUrl) {
    return (
        isCapCategoryProduct(categoryId) &&
        doesImageUrlContainHatTag(imageUrl)
    );
}

export function shouldApplyCapCategoryClassLoose(categoryId, imageUrl) {
    return (
        isCapCategoryProduct(categoryId) ||
        doesImageUrlContainHatTag(imageUrl)
    );
}

export function shouldApplyCapCategoryClass(categoryId, imageUrl) {
    return shouldApplyCapCategoryClassStrict(categoryId, imageUrl);
}
